module.exports = __webpack_public_path__ + "media/images/athletes/1738-8064c3862813ac592898c13ed84d860c.png";